import {Component} from "@angular/core";
import {environment} from "../environments/environment";
import {AuthService} from "./services/auth/auth.service";

@Component({
    selector: "app-root",
    templateUrl: "./app.component.html",
    styleUrls: ["./app.component.scss"]
})
export class AppComponent {
    constructor(public authService: AuthService) {
    }
    title = environment.appTitle;
}
